export default __webpack_public_path__ + "static/media/V.5bde88e3.svg";